module.exports = __webpack_public_path__ + "static/img/01.37abbe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/bruderertrans/01.jpg
// module id = 358
// module chunks = 1